import { createTypedExtendedFetch } from '@st/openapi-tools'
import type { paths as ApiSchema } from '../paths'
import { useApiConfig } from './useApiConfig'

export function useRawStFetch() {
  const { createApiConfig } = useApiConfig()

  return createTypedExtendedFetch<ApiSchema>(createApiConfig())
}
